import {
  AusschreibungsdiensteCTA,
  ClearFocussedType,
  FocussedHitsCount,
  getHitComponent,
} from "components/page-components/Internal-Search/utils"
import React, { useRef } from "react"

import { Arrow } from "components/page-components/Icons/small"
import { connectInfiniteHits } from "react-instantsearch-dom"

export const FocussedInfiniteHits = connectInfiniteHits(
  ({
    all_types,
    close_search_modal,
    hasMore,
    hits,
    main_search_ref,
    refineNext,
    searchState,
    setSearchState,
    set_focussed,
    types_without_tags,
  }) => {
    const main_type = searchState?.refinementList?.type[0]
    if (!hits.every(({ type }) => type === main_type)) {
      return <div></div>
    }
    const { HitsComponent, name } = getHitComponent({ type: main_type })
    const last_entry_ref = useRef(null)
    const scroll_to_top = () =>
      main_search_ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    const refine_next = () => {
      refineNext()
      setTimeout(() => {
        last_entry_ref.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }, 350)
    }
    return (
      <div
        className={`section px-0 ${
          types_without_tags.includes(main_type) ? "pt-0" : ""
        }`}
      >
        {main_type === "notice" ? (
          <AusschreibungsdiensteCTA {...{ searchState, close_search_modal }} />
        ) : (
          <div className="level is-mobile is-clipped px-3">
            <div className="level-left">
              <ClearFocussedType
                {...{
                  all_types,
                  searchState,
                  setSearchState,
                  set_focussed,
                  transformItems: (items) =>
                    items.filter(
                      ({ attribute }) =>
                        attribute === "type" || attribute === "tags"
                    ),
                }}
              />
              <div className="level-item">
                <p className="title is-4 has-text-white">{name}</p>
              </div>
              <FocussedHitsCount />
            </div>
          </div>
        )}

        <HitsComponent {...{ hits, last_entry_ref, close_search_modal }} />

        {hasMore ? (
          <div className="buttons is-centered are-small">
            <button
              onClick={refine_next}
              className="button is-tertiary has-text-weight-bold "
            >
              Mehr laden
            </button>
            <button onClick={scroll_to_top} className="button is-white-20 ">
              <Arrow {...{ direction: "up", size: 0.5, color: "#FFFFFF" }} />
            </button>
          </div>
        ) : null}
      </div>
    )
  }
)
